import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useLocation, useParams, useSearchParams } from 'react-router-dom'
import { LinearProgress } from '@mui/material'
import styled from '@emotion/styled'
import { H3 } from '../../../layouts/TextStyles'
import { sectionApiSlice } from '../../../features/section/sectionSlice'
import GroupStudentsTable from './components/GroupStudentsTable'
import Breadcrumb from '../../../components/Breadcrumb'

const GroupStudentsPage = () => {
    const { formatMessage } = useIntl()
    const { state } = useLocation()
    const { groupId } = useParams()
    const [searchParams, setSearchParams] = useSearchParams('')
    const [page, setPage] = React.useState(
        Number(searchParams.get('page')) || 1,
    )
    const [rowsPerPage, setRowsPerPage] = React.useState(
        Number(searchParams.get('size')) || 5,
    )
    const { data: studentResponse = null, isFetching } =
        sectionApiSlice.useGetStudentsSectionAnalysisByGroupQuery({
            groupId: +groupId,
            page: +page - 1,
            size: +rowsPerPage,
        })

    useEffect(() => {
        const params = {
            page: page.toString(),
            size: rowsPerPage.toString(),
        }
        setSearchParams(params, { state })
    }, [rowsPerPage, page])

    return (
        <Wrapper>
            <Breadcrumb
                links={[
                    formatMessage({ id: 'groups' }),
                    formatMessage({ id: 'studentsList' }),
                ]}
            />

            <Content>
                <Header>
                    <Title>
                        <H3>
                            {formatMessage({ id: 'students' })}{' '}
                            {state?.group?.title}
                        </H3>
                    </Title>
                </Header>

                {isFetching ? (
                    <LinearProgress />
                ) : (
                    studentResponse && (
                        <GroupStudentsTable
                            students={studentResponse.data}
                            pageNumber={studentResponse.pageNumber}
                            totalCount={studentResponse.totalCount}
                            isFetching={isFetching}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            setPage={setPage}
                            setRowsPerPage={setRowsPerPage}
                        />
                    )
                )}
            </Content>
        </Wrapper>
    )
}

export default GroupStudentsPage

const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`
const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`

const Content = styled.div`
    background-color: #fff;
    border-radius: 16px;
    padding: 20px;
    min-height: 80vh;
`

const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`
